import React from 'react'
import { Modal } from 'react-bootstrap'
import ReactDraggable, { ControlPosition, DraggableBounds } from 'react-draggable'

import Portal from 'live/components/ui/PluginPortal'

import { DraggableModalStyled } from './styled'

interface IProps {
    onClose: () => void
    show: boolean
    height: number
    width: number
    header: string
    closeButton: boolean
    customBounds?: DraggableBounds
    customDefaultPosition?: ControlPosition
    style?: React.CSSProperties
}

export const DraggableModal: React.FC<IProps> = props => {
    const {
        children,
        onClose,
        show,
        height,
        width,
        header,
        closeButton = true,
        customBounds,
        customDefaultPosition,
        style
    } = props
    const effectiveHeight = header || closeButton ? height + 45 : height

    if (show === false) {
        return <></>
    }

    return (
        <Portal>
            <ReactDraggable
                handle=".modal-header"
                bounds={
                    customBounds ?? {
                        top: 16,
                        left: 16,
                        bottom: window.innerHeight - effectiveHeight - 16,
                        right: window.innerWidth - width - 16
                    }
                }
                defaultPosition={
                    customDefaultPosition ?? {
                        x: window.innerWidth / 2 - width / 2,
                        y: window.innerHeight / 2 - effectiveHeight / 2
                    }
                }
            >
                <DraggableModalStyled
                    style={{ ...style, width, height: effectiveHeight }}
                    onHide={onClose}
                    backdrop={false}
                    show
                >
                    {(header || closeButton) && (
                        <Modal.Header>
                            {header && <Modal.Title>{header}</Modal.Title>}
                            {closeButton && (
                                <button onClick={onClose}>
                                    <i className="fas fa-times"></i>
                                </button>
                            )}
                        </Modal.Header>
                    )}
                    <Modal.Body>{children}</Modal.Body>
                </DraggableModalStyled>
            </ReactDraggable>
        </Portal>
    )
}
